<template>
  <div class="editStaff">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12" class="topTips">
          <label>员工工号</label>
          {{form.staffNo}}
        </el-col>
        <el-col :span="12">
          <!-- <div class="borderBtn" style="margin-left:235px;cursor:pointer" @click="resetPwd(form.staffPhone)">重置登录密码</div> -->
        </el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :span="12">
          <el-form-item label="员工姓名" prop="staffName">
            <el-input v-model="form.staffName" placeholder="请输入员工姓名" style="width:190px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="staffPhone">
            <el-input placeholder="请输入联系方式" v-model="form.staffPhone" style="width:190px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :span="12">
          <el-form-item label="身份证号" prop="cardId">
            <el-input placeholder="请输入身份证号" v-model="form.cardId" style="width:230px" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入职时间" prop="hiredate"><el-date-picker type="date" placeholder="年/月/日" format="yyyy 年 MM 月 dd 日" v-model="form.hiredate" style="width: 190px;" value-format="timestamp"></el-date-picker></el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :span="12">
          <el-form-item label="年龄" prop="staffAge">
            <el-input v-model="form.staffAge" placeholder="请输入年龄" style="width:135px" readonly></el-input>&nbsp;&nbsp;岁
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="母婴店员工编号" prop="relateId">
            <el-input v-model="form.relateId" placeholder="母婴店员工编号" style="width:135px"></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
            <el-form-item label="学历" prop='education'>
                <el-select v-model="form.education" placeholder="请选择学历" style="width:190px">
                    <el-option :label="i.name" :value="i.id" v-for="(i,index) in infolist.educationList" :key="'education-'+index"></el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="岗位" prop='postId'>
                <el-select v-model="form.postId" placeholder="请选择岗位" style="width:190px">
                    <el-option :label="i.name" :value="i.id" v-for="(i,index) in postIdData" :key="index"></el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span='12' v-if="form.postId && form.postId == 0">
            <el-form-item label="调理师等级" prop='staffLevel'>
                <el-select v-model="form.staffLevel" placeholder="请选择调理师等级" style="width:190px">
                    <el-option label="初级调理师" value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="紧急联系人" prop='emergencyContact'>
                <el-input v-model="form.emergencyContact" placeholder="请输入紧急联系人" style="width:190px"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="紧急联系方式" prop='emergencyContactTelephone'>
                <el-input v-model="form.emergencyContactTelephone" placeholder="请输入紧急联系方式" style="width:190px"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关系" prop='relationshipId'>
                <el-select v-model="form.relationshipId" placeholder="请选择关系" style="width:190px">
                    <el-option :label="i.name" :value="i.id" v-for="(i,index) in infolist.staffrelationShipList" :key="'relationShip-'+index"></el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="结婚纪念日" prop='weddingDay'>
                <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="form.weddingDay" style="width: 190px;" value-format="MM-dd"></el-date-picker>
            </el-form-item>
        </el-col>
      </el-row>
      <el-row class="borTop">
        <el-col :span="24">
          <el-form-item label="有无工作经验" prop="isExperience">
            <el-radio-group v-model="form.isExperience">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <template v-if="form.isExperience == 1">
          <el-col v-for="(i,index) in form.experienceList" :key="'workPro'+index" class="workList">
            <div class="deleteWork" v-if="index > 0" @click="deleteOneExperience(index)"></div>
            <el-col :span='12'>
              <el-form-item label="就职时间" required>
                <el-col :span="11">
                  <el-form-item label-width="0" :prop="'experienceList.'+index+'.startTime'" :rules="rules.experienceList.startTime">
                    <el-date-picker v-model="i.startTime" type="date" placeholder="年/月/日" format="yyyy 年 MM 月 dd 日" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="2" style="text-align:center">至</el-col>
                <el-col :span="11">
                  <el-form-item label-width="0" :prop="'experienceList.'+index+'.endTime'" :rules="rules.experienceList.endTime">
                    <el-date-picker v-model="i.endTime" type="date" placeholder="年/月/日" format="yyyy 年 MM 月 dd 日" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="180px" label="就职公司" :prop="'experienceList.'+index+'.company'" :rules="rules.experienceList.company">
                <el-input v-model="i.company" placeholder="请输入就职公司" style="width:250px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="岗位" :prop="'experienceList.'+index+'.post'" :rules="rules.experienceList.post">
                <el-input v-model="i.post" placeholder="请输入岗位" style="width:250px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="180px" label="工作职责" :prop="'experienceList.'+index+'.duty'" :rules="rules.experienceList.duty">
                <el-input type="textarea" v-model="i.duty" style="width:250px;height:60px;" placeholder="300个汉字长度以内" resize="none"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <div class="addWork" @click="addExperienceList">增加工作经验</div>
          </el-col>
        </template>
      </el-row>   
      <el-row class="btnOptions">
        <el-button class="borderBtn" @click="deleteStaff" v-if="staffStatus == 3">删除</el-button>
        <el-button class="darkBtn" @click="resetData">取消</el-button>
        <el-button class="redBtn" @click="onSubmit">提交</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import infolist from '@/assets/js/info'
import { staffInfo, updateStaff, uploadUrl  } from "@/api";

export default {
  data() {
    /*验证手机号*/
    const isvalidateMobile = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^1[3456789]\d{9}$/.test(value) == false) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 验证身份证
    const isvalidatePerId = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value) == false) {
          callback(new Error("您输入的身份格式不正确,请检查"));
        } else {
          const staffBirth =
            value.substr(6, 4) +
            "/" +
            value.substr(10, 2) +
            "/" +
            value.substr(12, 2);
          const birthDate = new Date(staffBirth);
          let nowDateTime = new Date();
          let age = nowDateTime.getFullYear() - birthDate.getFullYear();
          //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
          if (
            nowDateTime.getMonth() < birthDate.getMonth() ||
            (nowDateTime.getMonth() == birthDate.getMonth() &&
              nowDateTime.getDate() < birthDate.getDate())
          ) {
            age--;
          }
          this.form.staffAge = age;
          callback();
        }
      } else {
        callback();
      }
    };
    // 验证字母和数字
    const isvalidateNumZ = (rule, value, callback) => {
      if (value && /^[0-9a-zA-Z]{0,30}$/.test(value) == false) {
        callback(new Error("请输入30位以内字母和数字"));
      } else {
        callback();
      }
    };
    //限制300字以内
    const isvalidateLimit = (rule, value, callback) => {
      if (value && value.length > 300) {
        callback(new Error("最多 300 个汉字长度"));
      } else {
        callback();
      }
    };
    // 商品展示图
    const validatePic = (rule, value, callback) => {
      setTimeout(() => {
        if (this.fileLength == 0) {
          callback(new Error("请上传至少一张图片"));
        } else {
          callback();
        }
      }, 200);
    };
    return {
      infolist:infolist,
      form: {
        staffPhone: "",
        staffName: "",
        cardId: "",
        hiredate: "",
        staffAge: "",
        // relateId: "",
        post: "",
        level: "",
        status: "1",
        remarks: "",
        education:'',
        emergencyContact:'',
        emergencyContactTelephone:'',
        relationshipId:'',
        weddingDay:'',
        isTrain:'',
        certificateNumber:'',
        isExperience:'',
        experienceList:[
          {
            startTime:'',
            endTime:'',
            company:'',
            post:'',
            duty:'',
          }
        ],
        files: [],
      },
      staffStatus: "",
      rules: {
        files: [{ required: true, validator: validatePic }],
        staffPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: isvalidateMobile, trigger: "blur" }
        ],
        staffName: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: "blur"
          }
        ],
        cardId: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: isvalidatePerId, trigger: "blur" }
        ],
        education:[
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        emergencyContact:[
          { min: 1, max: 15, message: "长度在 1 到 15 个字符", trigger: "blur"}
        ],
        emergencyContactTelephone:[
          { validator: isvalidateMobile, trigger: "blur" }
        ],
        isTrain:[
          { required: true, message: "请完善梅氏培训经历", trigger: "change" },
        ],
        certificateNumber:[
          { required: true, message: "请输入证书编号", trigger: "blur" },
        ],
        hiredate: [
          {
            required: true,
            message: "请选择入职时间",
            trigger: "change"
          }
        ],
        relateId: [{ validator: isvalidateNumZ, trigger: "change" }],
        postId: [{ required: true, message: "请选择岗位", trigger: "change" }],
        remarks: [{ validator: isvalidateLimit, trigger: "blur" }],
        isExperience:[
          { required: true, message: "请选择有无工作经验", trigger: "change" },
        ],
        experienceList:{
          startTime:[
            { required: true, message: "请选择开始时间", trigger: "change"}
          ],
          endTime:[
            { required: true, message: "请选择结束时间", trigger: "change"}
          ],
          company:[
            { required: true, message: "请输入就职公司", trigger: "blur" },
            { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur"}
          ],
          post:[
            { required: true, message: "请输入岗位", trigger: "blur" },
            { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur"}
          ],
          duty:[
            { required: true, message: "请输入工作职责", trigger: "blur" },
            { validator: isvalidateLimit, trigger: "blur" }
          ],
        }
      },
      dialogVisible:false,
      uploadUrl,
      fileImg: "",
      fileListData: [],
      fileLength: 0,
    };
  },
  watch: {
    '$route.params.id' (val){
      if(val){
        this.detailInfo();
      }
    }
  },
  computed: {
    postIdData(){
      let data = this.$store.state.userInfo.brandId == 1 ? this.infolist.postIdData1:(this.$store.state.userInfo.brandId == 2 ? this.infolist.postIdData2:(this.$store.state.userInfo.brandId == 3 ? this.infolist.postIdData3:this.infolist.postIdData));
      return data;
    },
    headerPost(){
      return {
        userId:this.$store.state.userInfo.staffId ? this.$store.state.userInfo.staffId : ''
      }
    }
  },
  created() {
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      staffInfo({
        staffId: this.$route.params.id
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          this.staffStatus = res.data.status;
          this.form.postId = this.form.postId ? Number(this.form.postId) : '';
          this.form.education = this.form.education ? Number(this.form.education):'';
          this.form.relationshipId = this.form.relationshipId ? Number(this.form.relationshipId):'';
          if(!this.form.experienceList){
            this.form.experienceList = this.$options.data().form.experienceList;
          }
          this.form.files = [];
          let fileImgs = [];
          if(this.form.healthCertificateUrl){
            fileImgs.push({
              url: this.form.healthCertificateUrl,
              name: this.form.healthCertificateUrl.split('/')[this.form.healthCertificateUrl.split('/').length-1]
            });
          }
          this.fileListData = fileImgs;
          this.fileLength = parseInt(this.fileListData.length);

          this.$nextTick(()=>{
            this.$refs.form.clearValidate()
          })
        }
      });
    },
    handleRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        return;
      } else {
        //   删除图片
        this.fileLength = fileList.length;
        this.form.healthCertificateUrl = '';
        this.form.files = [];
      }
    },
    handlePictureCardPreview(file) {
      this.fileImg = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        return;
      } else {
        if (file) {
          return this.$confirm(`确定移除 ${file.name}？`);
        } else {
          let imgNames = file.response.data.files[0].name;
          return this.$confirm(`确定移除 ${imgNames}？`);
        }
      }
    },
    uploadSuccess(response, file, fileList) {
      // 上传成功后的回调
      //   this.fileUrl.push(response.obj[0]);
      this.form.files.push({
        file: response.files[0].url,
        fileName: response.files[0].name
      });
    },
    uploadError(response, file, fileList) {
      // 上传错误
      this.$message({
        message: "上传失败，请重试！",
        type: "error"
      });
    },
    addFile(file, fileList) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (
        (!extension && !extension1 && !extension2 && !extension3) ||
        !isLt2M
      ) {
        return;
      } else {
        this.fileLength = fileList.length;
      }
    },
    beforeAvatarUpload(file) {
      const extension = file.name.split(".")[1] === "jpg";
      const extension1 = file.name.split(".")[1] === "png";
      const extension2 = file.name.split(".")[1] === "jpeg";
      const extension3 = file.name.split(".")[1] === "gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension1 && !extension2 && !extension3) {
        this.$message({
          message: "上传模板只能是 .jpg,.png,.jpeg,.gif 格式!",
          type: "error"
        });
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2M!");
      }
      return (extension || extension1 || extension2 || extension3) && isLt2M;
    },
    resetPwd(tel) {
      // 重置密码
      this.$router.push("/resetPwd/" + tel);
    },
    addExperienceList(){
      // 增加工作经验
      if(!this.form.experienceList){
        this.form.experienceList = [];
      }
      this.form.experienceList.push({
        startTime:'',
        endTime:'',
        company:'',
        post:'',
        duty:''
      });
    },
    deleteOneExperience(index) {
      // 删除工作经验
      this.form.experienceList.splice(index, 1);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.postId != 0) {
            delete this.form.staffLevel;
          }
          this.form.operateFlag = "1";
          if(this.form.isTrain != 1){
            this.form.certificateNumber = '';
          }
          if(this.form.isExperience != 1){
            this.form.experienceList = this.$options.data().form.experienceList;
          }
          this.form.healthCertificateUrl = this.form.files && this.form.files.length >0 ? this.form.files[0].file:this.form.healthCertificateUrl;
          updateStaff(this.form).then(res => {
            if (res.code == 1) {
              // 关闭当前进入列表页
              this.$store.commit("delete_tabs", this.$route.path);
              this.$store.commit("setAliveStatus", true); //保留列表页状态
              this.$router.push("/basicDataCenter/employeeBasicInfo");
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm(
        "确定要取消本次修改员工信息吗？取消后本次编辑的内容不保存",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续修改",
          cancelButtonText: "确定取消",
          type: "warning"
        }
      )
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$store.commit("delete_tabs", this.$route.path);
            this.$store.commit("setAliveStatus", true);//保留列表页状态
            this.$router.push("/basicDataCenter/employeeBasicInfo");
          }
        });
    },
    deleteStaff() {
      // 删除离职员工
      this.$confirm("确认要删除该员工的信息吗？确定删除后不可恢复", "提示", {
        confirmButtonText: "继续删除",
        cancelButtonText: "确定取消",
        type: "warning"
      })
        .then(() => {
          updateStaff({
            staffId: this.form.staffId,
            deleteFlag: "1",
            operateFlag: "2"
          }).then(res => {
            if (res.code == 1) {
              this.$store.commit("delete_tabs", this.$route.path);
              this.$store.commit("setAliveStatus", true); //保留列表页状态
              this.$router.push("/basicDataCenter/employeeBasicInfo");
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
.editStaff {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  .topTips {
    height: 46px;
    line-height: 46px;
    font-size: 15px;
    font-weight: bold;
    color: #222;
    margin-bottom: 40px;
    label {
      padding: 0 15px;
      width: 120px;
      text-align: right;
      display: inline-block;
      margin-right: 10px;
    }
  }
  .borderBtn {
    height: 46px;
    line-height: 46px;
    padding: 0 22px;
    border: 1px solid #f96479;
    color: #f83b56;
    font-weight: bold;
    display: inline-block;
    border-radius: 23px;
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
  }
  .staffTips {
    font-size: 13px;
    color: #666;
    margin: 60px 0;
    padding-left: 52px;
  }
  .workList{
    position: relative;
    .deleteWork{
      cursor: pointer;
      width: 22px;
      height: 22px;
      background: url(../../assets/images/store/dele.png) no-repeat center;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 999
    }
  }
  .addWork{
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.editStaff .el-radio__input.is-checked .el-radio__inner {
  border: none;
  background: url(../../assets/images/store/btn_select.png) no-repeat center;
}
.editStaff .el-radio__inner::after {
  width: 0;
}
.editStaff .el-radio__inner:hover {
  border: 1px solid #f83b56;
}
.editStaff .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
.editStaff .myselectTgas label {
  background: #abb1c3;
  height: 34px;
  line-height: 34px;
  padding: 0 14px;
  border-radius: 17px;
  margin: 0 6px 6px 0;
  &.is-active,
  &.is-checked {
    background: #f83b56;
    position: relative;
    &::after {
      content: "";
      width: 17px;
      height: 17px;
      position: absolute;
      background: url(../../assets/images/store/btn_select2.png) no-repeat
        center;
      background-size: contain;
      top: 0;
      right: -5px;
    }
  }
  .el-radio-button__inner,
  .el-checkbox-button__inner {
    background: none;
    border: none;
    padding: 0;
    color: #fff;
    box-shadow: none;
  }
}
.editStaff .btnOptions {
  text-align: center;
  margin-top: 50px;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/editStaff.vue